import {CustomControlTypeModel} from "./customControlType.model";

export class CustomFormModel {
    id :number;
    title :string;
    headertext :string;
    customControlTypes:Array<CustomControlTypeModel>; 
    

}

export class CustomFormValue{
    CustomFormValues:Array<CustomFormValueModel>;
    Id:number;
    controlType:number;
}

export class CustomFormValueModel {
   fieldName:string;
   fieldValue:string;
}

